// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__3zH7f","dropdown-item":"Header_dropdown-item__pzPF4","glifos-font":"Header_glifos-font__1nwqV"};